import { gql } from '../../types/__codegen__/ahm-api';

export const CREATE_LEADS = gql(`
  mutation createLeadMutation($input: createLeadInput) {
    createLead(input: $input) {
      id
    }
  }
`);
